export default __webpack_public_path__ + "static/media/social_media.cf3104dd.svg";